import React, { Component } from 'react';

class IconSquareCustom extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 13 13">
                    <path fill={this.props.squareColor} d="M0.233 0H12.838000000000001V12.605H0.233z"></path>
                </svg>
            </div>
        );
    }
}

export default IconSquareCustom;